import _ from 'lodash';
import { DrugAPI } from '../controllers/api';

class Method {
    _api;

    constructor(){
        this._api = new DrugAPI();

        this.getMethods = this.getMethods.bind(this);
    }

    getMethods(){
        return this._api.execute('getAdministrationMethods')
            .then(callback.bind(this))
            .catch(fallback.bind(this));

        ///------------

        function callback(output){
            output = _.uniqBy(_.map(output, (x) => { x.methodName = x.methodName.replace(/\  +/g, " "); return x; }), "methodName");
            return Promise.resolve( output );
        }
        function fallback(error){
            return Promise.reject(error);
        }
    }
}


export default Method;